import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../interfaces/product.interface';
import { PlanAttributes, SummaryView } from '../interfaces/plan-attributes.interface';
import { RecommendedPlans } from '../interfaces/recommended-plans.interface';
import { SubProductTypeOrder } from '../interfaces/sub-product-type-order.interface';

@Pipe({
    name: 'planSorter',
    standalone: false
})
export class PlanSorterPipe implements PipeTransform {

  /**
   * Sorts the plans by provided group:order config
   * puts recommend plans first
   * sorts finally by price
   */
  transform(
    plans: Product<PlanAttributes, SummaryView>[],
    subProductTypeOrder: SubProductTypeOrder[],
    recommendedPlanIds: RecommendedPlans
  ): Product<PlanAttributes, SummaryView>[] {
    return plans?.sort((a, b) => {

      if (subProductTypeOrder) {

        let sortOrderA = -1;
        let sortOrderB = -1;

        /** Pre-set order with recommended id config */
        if (recommendedPlanIds) {
          for (const key in recommendedPlanIds) {
            if (recommendedPlanIds[key]) {
              if (a.attributes.PLAN_ID === recommendedPlanIds[key]) {
                switch (key) {
                  case 'recommendedPlan':
                    sortOrderA = -300;
                    break;
                  case 'alternate1':
                    sortOrderA = -200;
                    break;
                  case 'alternate2':
                    sortOrderA = -100;
                    break;
                  default:
                    // console.error('Recommended Plans not identified with correct attributes');
                    break;
                }
              }

              if (b.attributes.PLAN_ID === recommendedPlanIds[key]) {
                switch (key) {
                  case 'recommendedPlan':
                    sortOrderB = -300;
                    break;
                  case 'alternate1':
                    sortOrderB = -200;
                    break;
                  case 'alternate2':
                    sortOrderB = -100;
                    break;
                  default:
                    // console.error('Recommended Plans not identified with correct attributes');
                    break;
                }
              }
            }
          }
        }

        subProductTypeOrder.forEach((subProductTypeOrderItem, index) => {

          /** Set order for A based on product type */
          if (
            a &&
            a.attributes &&
            a.attributes.SUB_PRODUCT_TYPE &&
            a.attributes.SUB_PRODUCT_TYPE.toUpperCase()
          ) {

            const aSubProductTypeUpper = a.attributes.SUB_PRODUCT_TYPE.toUpperCase();

            if (
              sortOrderA === -1 &&
              aSubProductTypeUpper === subProductTypeOrder[index].subProductType.toUpperCase()
            ) {
              sortOrderA = parseInt(subProductTypeOrder[index].order);
            }
          }

          /** Set order for B based on product type */
          if (b &&
            b.attributes &&
            b.attributes.SUB_PRODUCT_TYPE &&
            b.attributes.SUB_PRODUCT_TYPE.toUpperCase()) {

            const bSubProductTypeUpper = b.attributes.SUB_PRODUCT_TYPE.toUpperCase();

            if (sortOrderB === -1 &&
              bSubProductTypeUpper === subProductTypeOrder[index].subProductType.toUpperCase()) {

              sortOrderB = parseInt(subProductTypeOrder[index].order);
            }
          }
        });

        if (sortOrderA < sortOrderB) { return -1; }
        else if (sortOrderA > sortOrderB) { return 1; }
        else {
          let aPrice = a.price;
          let bPrice = b.price;

          if (typeof aPrice === 'string') {
            aPrice = Number(aPrice.split('-')[0]);
          }
          if (typeof bPrice === 'string') {
            bPrice = Number(bPrice.split('-')[0]);
          }

          if (aPrice < bPrice) { return -1; }
          else if (aPrice > bPrice) { return 1; }
          return 0;
        }
      } else {
        return 0;
      }
    });
  }

}
